import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button'
import SweetAlert from '../../Components/SweetAlert/SweetAlert';

const Susbcriptions = ({ type }) => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [deleteLoading, setDeleteLoading] = useState(false)

    const getRows = () => {
        setIsProccesing(true)
        Controllers.subscriptions.get_subscriptions().then(res => {
            setRows(res.data)
            setIsProccesing(false)
        })
    }

    useEffect(() => {
        getRows();
    }, [])

    const handleDelete = _ => {
        setDeleteLoading(true)
        Controllers.subscriptions.ban_subscriptions({
            p_id_subscription: dataDeleted.p_id_subscription
        }).then(res => {
            Helpers.toast.construct({ ...res, toast })

            if (res.response !== 'success') {
                return
            }
            
            getRows();
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setDeleteLoading(false)
                setShowConfirmDelete(false)
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_subscription', text: 'ID', align: 'center' },
                { name: 'created_at', text: 'Fecha Creación', align: 'center', },
                { name: 'last_payment', text: 'Último Pago', align: 'center', },
                { name: 'subscription_type', text: 'Método de Pago', align: 'center' },
                {
                    name: 'subscription_status', text: 'Estatus', align: 'center', render: r => {
                        let badge = ''
                        let text = ''
                        switch (parseInt(r.subscription_status)) {
                            case 1:
                                badge = 'success'
                                text = 'Activo'
                                break;

                            case 2:
                                badge = 'warning'
                                text = 'Suspendido'
                                break;

                            case 3:
                                badge = 'danger'
                                text = 'Cancelado'
                                break;

                            case 4:
                                badge = 'dark'
                                text = 'Expirado'
                                break;

                            default:
                                break;
                        }

                        if (!badge) {
                            return <></>
                        }

                        return <>
                            <div className={'badge badge-' + badge}>
                                {text}
                            </div>
                        </>
                    }
                },
                {
                    name: 'actions', text: <i className='fa fa-cog'></i>,
                    align: 'center', render: r => {
                        if (parseInt(r.subscription_status) !== 1) {
                            return <></>
                        }

                        return <Button size="xs" variant="danger" onClick={_ => {
                            setDataDeleted({
                                p_id_subscription: r.id_subscription
                            })
                            setShowConfirmDelete(true)
                        }}>
                            <div className='mb-2'><i className='fa fa-ban'></i>Anular</div>
                            <div>Suscripción</div>
                        </Button>
                    }
                }
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Mis Suscripciones</span>
            </Card.Header>
            <Card.Body>
                {dtRows}
            </Card.Body>
        </Card>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar suscripción?</>}
            subtitle={<>#{dataDeleted.p_id_subscription}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={deleteLoading}
            onCancel={() => setShowConfirmDelete(false)}
            onConfirm={handleDelete}
        />
    </>
}

Susbcriptions.defaultProps = {
    type: 'dashboard'
}

export default Susbcriptions